import React from 'react'
import { graphql, useStaticQuery, Link } from 'gatsby'

// Components
import { TitleDefault, ButtonAlt, ContentDefault } from 'components/Elements'

import './Sidebar.scss'

const Sidebar = () => {
  const { data } = useStaticQuery(graphql`
    {
      data: wordpressWpComponents(wordpress_id: { eq: 228 }) {
        acf {
          sidebar_title
          sidebar_content
          sidebar_button_text
          sidebar_button_link
        }
      }
    }
  `)

  return (
    <div className="col-12 pt-4 sidebar-cta text-center">
      <TitleDefault className="mb-3">{data.acf.sidebar_title}</TitleDefault>
      <ContentDefault>
        <div 
          dangerouslySetInnerHTML={{ __html: data.acf.sidebar_content }} 
        />
      </ContentDefault>
      <ButtonAlt to={data.acf.sidebar_button_link}>{data.acf.sidebar_button_text}</ButtonAlt>
    </div>
  )
}

export default Sidebar
